import React from "react";
import { useTranslation } from "react-i18next";
import { formatNumber, formatAmount, formatDollarAmount } from '../../../../../utils/methods';

interface CombinedInvoiceCardProps {
  totalAmountDue: number;
  totalInvoiceAmount: number;
  totalCommission: number;
  totalDraftInvoices: number;
  totalSentInvoices: number;
  totalCompletedInvoices: number;
}

const CombinedInvoiceCard: React.FC<CombinedInvoiceCardProps> = ({ 
  totalAmountDue, 
  totalInvoiceAmount, 
  totalCommission,
  totalDraftInvoices,
  totalSentInvoices,
  totalCompletedInvoices
}) => {
  const { t } = useTranslation();

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-sm-6 col-xl-6 border-end">
              <h5 className="mb-3 fw-bold">{t('layout.pageTexts.dashboard.pageTexts.currentMonthStats.titles.financialDetails')}</h5>
              <div className="d-flex flex-column gap-6">
                <div className="d-flex align-items-center">
                  <div className="avatar me-4">
                    <div className="avatar-initial bg-label-success rounded">
                      <i className="ri ri-file-list-3-line icon-24px"></i>
                    </div>
                  </div>
                  <div className="card-info">
                    <h5 className="mb-0">{formatDollarAmount((totalInvoiceAmount ?? 0).toString())}</h5>
                    <p className="mb-0">{t('layout.pageTexts.dashboard.pageTexts.currentMonthStats.labels.totalInvoicesAmount')}</p>
                  </div>
                </div>
                
                <div className="d-flex align-items-center">
                  <div className="avatar me-4">
                    <div className="avatar-initial bg-label-info rounded">
                      <i className="ri ri-percent-line icon-24px"></i>
                    </div>
                  </div>
                  <div className="card-info">
                    <h5 className="mb-0">{formatDollarAmount((totalCommission ?? 0).toString())}</h5>
                    <p className="mb-0">{t('layout.pageTexts.dashboard.pageTexts.currentMonthStats.labels.totalCommission')}</p>
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  <div className="avatar me-4">
                    <div className="avatar-initial bg-label-warning rounded">
                      <i className="ri ri-money-dollar-circle-line icon-24px"></i>
                    </div>
                  </div>
                  <div className="card-info">
                    <h5 className="mb-0">{formatDollarAmount((totalAmountDue ?? 0).toString())}</h5>
                    <p className="mb-0">{t('layout.pageTexts.dashboard.pageTexts.currentMonthStats.labels.totalAmountDue')}</p>
                  </div>
                </div>
                
              </div>
            </div>

            <div className="col-sm-6 col-xl-6">
              <h5 className="mb-3 fw-bold">{t('layout.pageTexts.dashboard.pageTexts.currentMonthStats.titles.invoiceStatistics')}</h5>
              <div className="d-flex flex-column gap-6">
                <div className="d-flex align-items-center">
                  <div className="avatar me-4">
                    <div className="avatar-initial bg-label-success rounded">
                      <i className="ri ri-checkbox-circle-line icon-24px"></i>
                    </div>
                  </div>
                  <div className="card-info">
                    <h5 className="mb-0">{formatNumber(totalCompletedInvoices)}</h5>
                    <p className="mb-0">{t('layout.pageTexts.dashboard.pageTexts.currentMonthStats.labels.completed')}</p>
                  </div>
                </div>
                
                <div className="d-flex align-items-center">
                  <div className="avatar me-4">
                    <div className="avatar-initial bg-label-info rounded">
                      <i className="ri ri-send-plane-line icon-24px"></i>
                    </div>
                  </div>
                  <div className="card-info">
                    <h5 className="mb-0">{formatNumber(totalSentInvoices)}</h5>
                    <p className="mb-0">{t('layout.pageTexts.dashboard.pageTexts.currentMonthStats.labels.sent')}</p>
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  <div className="avatar me-4">
                    <div className="avatar-initial bg-label-warning rounded">
                      <i className="ri ri-draft-line icon-24px"></i>
                    </div>
                  </div>
                  <div className="card-info">
                    <h5 className="mb-0">{formatNumber(totalDraftInvoices)}</h5>
                    <p className="mb-0">{t('layout.pageTexts.dashboard.pageTexts.currentMonthStats.labels.draft')}</p>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CombinedInvoiceCard;

